import React from 'react';
import { DesktopOnly } from 'shared/components';
import { TabHeaderTitle } from 'src/account/components';

import { Loyalty } from 'src/components/loyalty';

export const LoyaltyPanel = (): JSX.Element => (
  <>
    <DesktopOnly>
      <TabHeaderTitle tag='h1' size='medium'>
        Loyalty
      </TabHeaderTitle>
    </DesktopOnly>

    <Loyalty />
  </>
);
